// src/templates/TreeMapPage/TreeMapPage.tsx

import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { TreeMapOrganism } from 'design-system/my-lib';
import ContextEditorPage from '../ContextEditorPage/ContextEditorPage';
import { selectSphereId } from '@center-pwa/selectors/selectors';
import { setSphereId } from '@center-pwa/reducers/sphereReducer';
import type { RootState, AppDispatch } from '@center-pwa/store/store';
import Header from '../Header/Header';

const TreeMapPage: React.FC = () => {
  const { sphereId, contextSystemName } = useParams<{ sphereId: string; contextSystemName: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  // Redux state selectors
  const selectedSphereId = useSelector((state: RootState) => selectSphereId(state));
  const userLocale = useSelector((state: RootState) => state.userProfile?.locale ?? 'en-US');
  const organizationId = useSelector((state: RootState) => state.userProfile?.userSphere?.properties?.sphereId);

  /**
   * Sync sphereId from route params with Redux store
   */
  useEffect(() => {
    if (sphereId && sphereId !== selectedSphereId) {
      dispatch(setSphereId({ sphereId, source: 'TreeMapPage' }));
    }
  }, [sphereId, selectedSphereId, dispatch]);

  const handleNodeSelect = (nodeId: string) => {
    // TODO: Navigate to sphere detail view or update selected sphere in Redux
  };

  return (
    <>
      <Header
        sphereId={selectedSphereId}
        defaultLanguage={userLocale}
      />
      <div style={{ height: 'calc(100vh - 60px)', overflow: 'auto' }}>
        {sphereId && contextSystemName && organizationId && (
          <TreeMapOrganism
            contextSystemName={contextSystemName}
            organizationId={organizationId}
            rootSphereId={sphereId}
            editable={true}
            onNodeSelect={handleNodeSelect}
            showBreadcrumbs={true}
            showFilters={true}
            showAI={true}
            defaultPageSize={5}
            useGridLayout={true}
            onNewContext={() => navigate('/studio/context/new')}
            onManageContexts={() => navigate('/studio/context')}
            onEditContext={(systemName) => navigate(`/studio/context/${systemName}`)}
            renderContextEditor={({ contextSystemName: ctxSn, onBack, onClose }) => (
              <ContextEditorPage
                inline
                inlineSystemName={ctxSn}
                onBack={onBack}
                onClose={onClose}
              />
            )}
          />
        )}
      </div>
    </>
  );
};

export default TreeMapPage;
